const getAppInitialModel = () => {
    let initialState = null;
    const jsonScript = document.getElementById("__INITIAL_STATE__");
    if (jsonScript) {
        initialState = JSON.parse(jsonScript.innerText);
        jsonScript.remove();
    }
    return initialState ? initialState.rootModel : undefined;
};
export default getAppInitialModel;
